import React, { Component } from "react";
import ClinicBasicInfoView from "./ClinicBasicInfoView";

export default class ClinicBasicInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {}
    };
  }

  render() {
    const { details, handleEditLocation } = this.props;

    return (
      <>
        {details && (
          <ClinicBasicInfoView
            details={details}
            handleEditLocation={handleEditLocation}
          />
        )}
      </>
    );
  }
}
